export default __webpack_public_path__ + "static/join03-81c2190860a83dc009cd2aea38c2655c.png";